import React from "react";

import withAuth from "../../../hoc/withAuth";
import MainLayout from "../../../components/layouts/MainLayout";

import { miscservices } from "../../../services/MiscServices";

import { Upload, Button, Table, Form, Col, Row, Modal, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";

class UploadAnalizeMultipleNotice extends React.Component {
  constructor(props) {
    super(props);

    const { match } = this.props;
    const code_svb = match.params.code_svb;

    this.state = {
      code_svb: code_svb,
      fileList: [],
      loadingButton: false,
      dataLog: [],
      summaryData: null,
    };
  }

  handleChange = (info) => {
    const fileList = info.fileList;

    const actualFiles = fileList.map((file) => file.originFileObj || file);

    const excelFiles = actualFiles.filter((file) => file.name.endsWith(".xlsx") || file.name.endsWith(".xls"));

    const imageFiles = actualFiles.filter((file) => file.type?.startsWith("image/"));

    if (excelFiles.length > 1) {
      message.error("Hanya boleh mengunggah 1 file Excel");
      return;
    }

    if (imageFiles.length > 7) {
      message.error("Maksimal 7 file gambar");
      return;
    }

    const invalidFile = actualFiles.find((file) => {
      return !(file.name.endsWith(".xlsx") || file.name.endsWith(".xls") || file.type?.startsWith("image/"));
    });

    if (invalidFile) {
      message.error("Hanya mendukung file Excel (.xlsx, .xls) dan gambar (jpg/png/jpeg)");
      return;
    }

    this.setState({ fileList });
  };

  handleRemove = (file) => {
    this.setState((prev) => ({
      fileList: prev.fileList.filter((f) => f.uid !== file.uid),
    }));
  };

  handleUpload = async () => {
    const { fileList, code_svb } = this.state;

    if (!code_svb) {
      Modal.error({
        title: "Error Validasi",
        content: "Terjadi kesalahan Kode Biro Jasa Kosong",
      });
      return false;
    }

    const hasExcel = fileList.some((file) => file.name.endsWith(".xlsx") || file.name.endsWith(".xls"));

    if (!hasExcel) {
      Modal.error({
        title: "Error Validasi",
        content: "File Excel Tidak Ditemukan",
      });
      return false;
    }

    const formData = new FormData();
    formData.append("code", code_svb);
    formData.append("document_type", "VEHICLETAXNOTICE");

    fileList.forEach((file) => {
      formData.append("documents", file.originFileObj || file);
    });

    this.setState({ loadingButton: true });

    const totalSize = fileList.reduce((sum, file) => {
      const realFile = file.originFileObj || file;
      return sum + (realFile.size || 0);
    }, 0);

    try {
      const response = await miscservices.uploadAnalizeMultiNotice(formData);
      const resData = response?.data?.data;
      const resultLog = resData?.log || {};
      const logs = Object.values(resultLog).flat();

      this.setState({
        dataLog: logs,
        summaryData: {
          batchId: resData?.batch_id,
          batchStatus: resData?.batch_status,
          imageCount: resData?.image_count,
          vehicleCount: resData?.vehicle_count,
          message: response?.data?.message,
        },
        loadingButton: false,
      });

      Modal.success({
        title: "Upload Berhasil",
        content: response?.data?.message,
      });
    } catch (error) {
      this.setState({ loadingButton: false });
      console.error("handleUpload error:", error);

      let message = error?.message || "Terjadi kesalahan saat mengunggah file.";
      if (message.includes("file terlalu besar")) {
        message += ` (${(totalSize / 1024 / 1024).toFixed(2)} MB)`;
      }

      Modal.error({
        title: "Upload Gagal",
        content: message,
      });
    }
  };

  render() {
    const { dataLog, loadingButton, fileList, summaryData } = this.state;

    const columns = [
      {
        title: "Waktu",
        dataIndex: "time",
        key: "time",
        width: 100,
      },
      {
        title: "Nomor Mesin",
        dataIndex: "key",
        key: "key",
        width: 150,
      },
      {
        title: "Keterangan",
        dataIndex: "desc",
        key: "desc",
        width: 200,
      },
    ];

    return (
      <React.Fragment>
        <MainLayout defaultOpenKeys={["7dokumen", "8notice"]} defaultSelectedKeys={["10uploadmultinotice"]}>
          <div style={{ padding: 16, margin: 10, background: "#FFF" }}>
            <Form layout="vertical">
              <Row gutter={16}>
                <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 8 }} sm={{ span: 24 }}>
                  <div style={{ marginBottom: 10 }}>
                    <Upload.Dragger beforeUpload={() => false} multiple fileList={fileList} onChange={this.handleChange} onRemove={this.handleRemove} accept=".xlsx,.xls,image/*">
                      <p className="ant-upload-drag-icon" style={{ color: "#DDD" }}>
                        <UploadOutlined style={{ color: "#DDD" }} />
                      </p>
                      <p className="ant-upload-hint">Klik atau Drag untuk mengunggah</p>
                      <p className="ant-upload-hint">Maksimal Upload 7 file. Wajib ada 1 File Excel</p>
                    </Upload.Dragger>
                  </div>
                  <Button
                    type="primary"
                    onClick={this.handleUpload}
                    loading={loadingButton}
                    style={{
                      background: "#1784b8",
                      borderColor: "#1784b8",
                    }}
                    block
                  >
                    Upload dan Analisa Notice
                  </Button>
                  <Button type="default" block style={{ marginTop: 8 }} onClick={() => window.open("https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/vehicle-document/image/notice/Sample.xlsx", "_blank")}>
                    Download Contoh File Excel
                  </Button>
                  <div style={{ marginTop: 12, fontSize: 12, color: "#555", lineHeight: "1.8" }}>
                    <b>Ketentuan Upload:</b>
                    <ul style={{ paddingLeft: 16, marginTop: 4 }}>
                      <li>
                        Wajib menyertakan <b>1 file Excel</b> dan maksimal <b>7 file gambar</b> (JPG/PNG/JPEG) dalam satu kali upload.
                      </li>
                      <li>
                        Setiap file gambar <b>harus diberi nama sesuai Nomor Mesin</b> kendaraan (contoh: <i>JMH2E1892666.jpg</i>). Nama file yang tidak sesuai akan menyebabkan proses analisa gagal.
                      </li>
                      <li>
                        Proses scanning gambar oleh AI akan diselesaikan dalam waktu <b>maksimal 1 hari kerja</b>. Selama proses berjalan, status scan notice akan tercatat sebagai <b>PENDING</b>.
                      </li>
                      <li>
                        <b>Hindari upload data beberapa kali.</b> Mengunggah ulang file yang sama atau sudah pernah diproses dapat menyebabkan <b>error dan konflik data</b> pada sistem.
                      </li>
                      <li>
                        Pantau hasil dan status scanning melalui menu <b>Log Multi Upload Notice</b>.
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 18 }} lg={{ span: 18 }} md={{ span: 18 }} sm={{ span: 24 }}>
                  Log Hasil Upload
                  <Table columns={columns} dataSource={dataLog.filter((item) => !item.hidden)} loading={loadingButton} rowKey={(record, index) => `${record.key}-${index}`} size="small" pagination={false} />
                  {summaryData && (
                    <table style={{ marginTop: 16, fontWeight: "bold", borderCollapse: "collapse" }}>
                      <tbody>
                        {summaryData.message && (
                          <tr>
                            <td colSpan={8} style={{ paddingTop: 8, color: "#555" }}>
                              {summaryData.message}
                              <br />
                              ID Task : <i>{summaryData.batchId}</i>
                              <br />
                              Status : {summaryData.batchStatus.toUpperCase()}
                              <br />
                              Jumlah Gambar Di Proses : {summaryData.imageCount}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </Col>
              </Row>
            </Form>
          </div>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(UploadAnalizeMultipleNotice);
